/**
 * The column a screen's content sits in, centred, at one of three widths: `narrow` for a form or
 * a single record, `medium` for customer pages and detail pages, `wide` for tables. The side
 * gutters are 16px on a phone, 24px on a tablet and 32px on a desktop, so every screen in every
 * app lines up with the one before it.
 */
import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import "@lattice/tokens/size.stylex";
import { size } from "@lattice/tokens/size.stylex";
import "@lattice/tokens/space.stylex";
import { space } from "@lattice/tokens/space.stylex";
import "@lattice/tokens/breakpoints.stylex";
import { breakpoints } from "@lattice/tokens/breakpoints.stylex";
const styles = {
  column: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x15agyyk",
    kB7OPa: "x9f619",
    kzqmXN: "xh8yej3",
    k7Eaqz: "xeuugli",
    kUOVxO: "xvueqy4",
    kg3NbH: "x3i8z2n x1tg053j x1823pzw",
    k8WAf4: "xfjredr",
    $$css: true
  },
  narrow: {
    ks0D6T: "xs5k50",
    $$css: true
  },
  medium: {
    ks0D6T: "x1susnil",
    $$css: true
  },
  wide: {
    ks0D6T: "x1sb7ehz",
    $$css: true
  }
};
export type ContentWidth = "narrow" | "medium" | "wide";
export interface ContentProps {
  readonly width?: ContentWidth;
  readonly testId?: string;
  readonly children: ReactNode;
}
export function Content({
  width = "medium",
  testId,
  children
}: ContentProps) {
  return <div data-testid={testId} {...stylex.props(styles.column, styles[width])}>
      {children}
    </div>;
}